var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"d-none",attrs:{"multiple":_vm.multiple}},[(_vm.multiple!='multiple')?_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Seleccionar")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }